module.exports = __webpack_public_path__ + "img/sort-up.375cf81c.svg";